import Default from "../Pages/Dashboard/Default/Default";
import UserManagement from "../Pages/Application/Users/UserManagement/UserManagement";
import UsersProfile from "../Pages/Application/Users/UsersProfile/UsersProfile";
import EditProfile from "../Pages/Application/Users/EditProfile/EditProfile";
import UserCards from "../Pages/Application/Users/UserCards/UserCards";
import RolesManagement from "../Pages/Application/Roles/RolesManagement";
import PermissionsManagement from "../Pages/Application/Permissions/PermissionsManagement";
import LegalConsultationsList from "../Component/Application/LegalConsultations/LegalConsultationsList";
import AppointmentDetail from "../modules/appointments/pages/Detail";
import CountriesManagement from "../Pages/Application/Countries/CountriesManagement";
import AppVersionsManagement from "../Pages/Application/AppVersions/AppVersionsManagement";
import AccessHistory from "../Pages/Application/AccessHistory/AccessHistory";
import CaseFollowUp from "../Pages/Application/CaseFollowUp/CaseFollowUp";
import CaseFollowUpDetail from "../Component/Application/CaseFollowUp/CaseFollowUpDetail";
import Notifications from "../Pages/Application/Notifications/Notifications";

// Las rutas no deben incluir PUBLIC_URL porque ya está en el basename del BrowserRouter
const Routes = [
  { path: "/dashboard/default", Component: <Default /> },
  { path: "/users/management", Component: <UserManagement /> },
  { path: "/users/userprofile", Component: <UsersProfile /> },
  { path: "/users/useredit", Component: <EditProfile /> },
  { path: "/users/cards", Component: <UserCards /> },
  { path: "/roles/management", Component: <RolesManagement /> },
  { path: "/permissions/management", Component: <PermissionsManagement /> },
  { path: "/appointments/list", Component: <LegalConsultationsList /> },
  { path: "/appointments/:id", Component: <AppointmentDetail /> },
  { path: "/countries/management", Component: <CountriesManagement /> },
  { path: "/app-versions/management", Component: <AppVersionsManagement /> },
  { path: "/access-history", Component: <AccessHistory /> },
  { path: "/case-follow-up", Component: <CaseFollowUp /> },
  { path: "/case-follow-up/detail/:caseNumber", Component: <CaseFollowUpDetail /> },
  { path: "/notifications", Component: <Notifications /> },
];

export default Routes;
